import { render } from "./index.vue?vue&type=template&id=63b0feb8&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=63b0feb8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b0feb8"]])

export default __exports__